import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { isIosNonSafari } from '../pwa/pwaInstallUtils';
import { ModalCloseButton } from './icons/AdminUiIcons';
import './pwa-install.css';

function PwaInstallGuideShell({ show, onClose, titleId, title, children }) {
  useEffect(() => {
    if (!show) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [show, onClose]);

  if (!show) return null;

  return createPortal(
    <>
      <div
        className="modal-backdrop fade show pwa-install-guide-backdrop"
        aria-hidden
        onClick={onClose}
      />
      <div
        className="modal fade show d-block pwa-install-ios-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow">
            <div className="modal-header border-0 pb-0">
              <h2 className="modal-title h5" id={titleId}>
                {title}
              </h2>
              <ModalCloseButton onClick={onClose} />
            </div>
            {children}
            <div className="modal-footer border-0 pt-0">
              <button type="button" className="btn btn-wine w-100" onClick={onClose}>
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}

export function PwaAndroidInstallModal({ show, onClose }) {
  return (
    <PwaInstallGuideShell
      show={show}
      onClose={onClose}
      titleId="pwa-install-android-title"
      title="Install Saloni Designs"
    >
      <div className="modal-body pt-2">
        <ol className="pwa-install-ios-modal__steps small mb-0">
          <li>
            Tap the browser menu <strong>⋮</strong> (top right in Chrome).
          </li>
          <li>
            Choose <strong>Install app</strong> or <strong>Add to Home screen</strong>.
          </li>
          <li>Confirm — the app icon will appear on your home screen.</li>
        </ol>
      </div>
    </PwaInstallGuideShell>
  );
}

export function PwaIosInstallModal({ show, onClose }) {
  const openInSafari = isIosNonSafari();

  return (
    <PwaInstallGuideShell
      show={show}
      onClose={onClose}
      titleId="pwa-install-ios-title"
      title="Add Saloni Designs to your home screen"
    >
      <div className="modal-body pt-2">
        {openInSafari ? (
          <p className="small text-muted mb-3">
            For the install option, open this site in <strong>Safari</strong> first (copy the
            link from your browser&apos;s menu if needed).
          </p>
        ) : null}
        <ol className="pwa-install-ios-modal__steps small mb-0">
          <li>
            Tap the Share button{' '}
            <span className="pwa-install-ios-modal__share-icon" aria-hidden>
              ↑
            </span>{' '}
            at the bottom of Safari (or the top bar on iPad).
          </li>
          <li>
            Scroll the menu and choose <strong>Add to Home Screen</strong>.
          </li>
          <li>
            Tap <strong>Add</strong> — the Saloni Designs icon will appear on your home screen
            like an app.
          </li>
        </ol>
      </div>
    </PwaInstallGuideShell>
  );
}
